import {experimentalStyled as styled} from "@mui/material/styles";

const MessageWrapper = styled("div")(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  padding: "40px",
}));

const EmptySearchResults = () => {
  return (
    <MessageWrapper>
      <h1>No Matching Users</h1>
      <div>Please change your search term to get more results</div>
    </MessageWrapper>
  );
};

export default EmptySearchResults;
